import { getSessionToken } from "@shopify/app-bridge-utils";
import axios from 'axios';

const csrfToken = document.querySelector("[name=csrf-token]").content;
// const shopDomain = document
//   .querySelector("#shopify-app-init")
//   .getAttribute("data-shop-origin");

const lmsAPI = axios.create({
  baseURL: "/api/",
  headers: {
    "X-CSRF-TOKEN": csrfToken,
  },
});

lmsAPI.interceptors.response.use((response) => {
  if (response.data?.redirect_to_url) {
    window.location.href = response.data.redirect_to_url;
  }
  return response;
});

lmsAPI.interceptors.request.use(async (request) => {
  const sessionToken = await getSessionToken(window.app);
  request.headers["Authorization"] = `Bearer ${sessionToken}`;
  return request;
});

export default lmsAPI;
